const USER_LOGGED_IN_EVENT = "user-logged-in";
const USER_LOGGED_OUT_EVENT = "user-logged-out";


export {
    USER_LOGGED_IN_EVENT,
    USER_LOGGED_OUT_EVENT
}